module.exports = __webpack_public_path__ + "static/media/sbf-arrow-circle.e9ecea87.png";